// extracted by mini-css-extract-plugin
module.exports = {"textarea":"OwnCode_textarea__21ihN","textareaContainer":"OwnCode_textareaContainer__1gDLn"};